import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';

import { App } from '@capacitor/app';

import { DrawerContext } from 'src/components/drawers/DrawerManager';
import { AUTH0_CALLBACK_PATH, SSO_DIRECT_LOGIN_PATH } from 'src/constants/Auth0';
import { onHardwareBack } from 'src/native/backButton';

const LOGIN_PATH = '/authenticate';

const InertBackPathSet = new Set<string>([LOGIN_PATH, AUTH0_CALLBACK_PATH, SSO_DIRECT_LOGIN_PATH]);

/**
 * Owns the Android hardware back gesture. Headless.
 *
 * Deliberately minimal: close an open drawer, do nothing on the auth routes, otherwise walk history,
 * and exit at the root.
 */
function HardwareBackButton() {
    const { closeDrawer, isDrawerOpen } = useContext(DrawerContext);
    const { pathname } = useLocation();

    useEffect(() => {
        // Re-registered whenever isDrawerOpen or pathname change, since the handler closes over
        // both; a stale handler would judge the press against the wrong screen.
        const unsubscribe = onHardwareBack(({ canGoBack }) => {
            if (isDrawerOpen) {
                closeDrawer();
            } else if (InertBackPathSet.has(pathname)) {
                // Intentionally inert.
            } else if (canGoBack) {
                window.history.back();
            } else {
                App.exitApp().catch(() => {});
            }
        });

        return unsubscribe;
    }, [closeDrawer, isDrawerOpen, pathname]);

    return null;
}

export default HardwareBackButton;
